module.exports = __webpack_public_path__ + "img/R. Shaul Benzadon.11e67ad8.png";